import GenericRequest, { METHOD_POST } from '../../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../../shared/webservices/endpoint';
import RouterUtils from '../../../../../shared/routing/RouterUtils';

export default class ArchiveMessageRequest extends GenericRequest {

    constructor(message_id) {
        super(METHOD_POST, RouterUtils.generateRoute(ApiEndpoints.MESSAGES_ARCHIVE_ID, { id: message_id }));
    }

}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/to-refactor/shared/ws/ArchiveMessageRequest.js